import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAbatementIcon, LazyAddManageSectionsButton, LazyAlphabeticSortIcon, LazyAmoqComment, LazyAmoqCommentThread, LazyAmoqGuidance, LazyAmoqQuestion, LazyAmoqQuestionSelect, LazyAmoqQuestionSummary, LazyAmoqQuestionsNavigation, LazyAnimatedCircleLoader, LazyAnimatedPing, LazyApproveApprovalModal, LazyArchiveIcon, LazyArrowDownIcon, LazyArrowNarrowLeftSmall, LazyArrowUpIcon, LazyArrowUpTray, LazyArrowVector, LazyArrowWideLeft, LazyAssetChartBreakdown, LazyAssetTreeNode, LazyAssetsTreeSelector, LazyAssignRolesModal, LazyAsyncMultiSelector, LazyAttachmentListContainer, LazyAttachmentListModal, LazyAttachmentViewer, LazyAutoCompleteInput, LazyBankIcon, LazyBarsArrowUp, LazyBaseButton, LazyBaseYearToggle, LazyBellSmall, LazyBenefitCard, LazyBenefitsSection, LazyBlockedAlert, LazyBoldIcon, LazyBoltDuotone, LazyBookmarkIcon, LazyBooleanIconOrDescription, LazyBorderedRadioButtonWithInfo, LazyBoxIcon, LazyBoxUploadIcon, LazyBreadCrumb, LazyBriefCase, LazyBuildingIcon, LazyBulletListIcon, LazyBusIcon, LazyButtonWithIcon, LazyCTASection, LazyCalendarIcon, LazyCallIcon, LazyCarbonEquivalenceCalculator, LazyCarbonEquivalenceCalculatorNew, LazyCarbonFire, LazyCartIcon, LazyCategoriesOvertimeBadges, LazyCategoryButton, LazyChartIcon, LazyCheckApproval, LazyCheckCircleIcon, LazyCheckOutlineIcon, LazyCheckRejected, LazyCheckRoundedSmall, LazyCheckSmall, LazyCheckboxAnswer, LazyChevronDoubleDownSmall, LazyChevronDoubleUpSmall, LazyChevronDownLarge, LazyChevronDownSmall, LazyChevronLeftSmall, LazyChevronNav, LazyChevronRightSmall, LazyChevronUpSmall, LazyCircleRoundedIcon, LazyClockIcon, LazyCloseIcon, LazyCloseRoundedIcon, LazyCloudDownload, LazyCloudIcon, LazyCloudUpload, LazyCloudUploadSmall, LazyCodeHighlight, LazyCogIcon, LazyComingSoonIllustration, LazyCommentText, LazyConfigureEsgMetricsEmptyState, LazyConfigureGhgEmissionFactorModal, LazyConfirmDialog, LazyConfirmEditSubmissionModal, LazyConfirmMessageModal, LazyConnectIcon, LazyConsolidationApproachSelectionModal, LazyCrudMetricForm, LazyCsvLarge, LazyCtaSection, LazyCubeIcon, LazyCustomDashboardTab, LazyDashboardIcon, LazyDashboardNavbarComponent, LazyDataAssignmentBulkImportForm, LazyDataAssignmentModal, LazyDataAssignmentNodeSelector, LazyDataAssignmentRadioSelector, LazyDataAssignmentTable, LazyDataAssignmentTreeSelector, LazyDataAssignmentUserSelector, LazyDataEntryDocument, LazyDataPointAttachmentContainer, LazyDataRangeFilter, LazyDataTableEmptyState, LazyDatapointIntegration, LazyDatePicker, LazyDateRangeIcon, LazyDateRangePicker, LazyDecentWorkAndEconomicGrowth, LazyDestructivePrimaryButton, LazyDotsHorizontal, LazyDotsVerticalSmall, LazyDottedCircleIcon, LazyDoubleCheck, LazyDownloadIcon, LazyDraftQuestionsTable, LazyDragDropInput, LazyDropDown, LazyDropDownInput, LazyDropFileInput, LazyDropdownAnswer, LazyDropdownIcon, LazyDropdownMenu, LazyDropdownMenuItem, LazyEarthSettingIcon, LazyEditEmissionAuditLogModal, LazyEditGhgEmissionFactorModal, LazyEditGhgEmissionFactorReviewModal, LazyEditUserIcon, LazyElpHorizontal, LazyElpIcon, LazyEmissionByCategoryOverTimeChart, LazyEmissionByScopeOverTimeChart, LazyEmissionFactorItem, LazyEmissionFactorPicker, LazyEmissionIntensityCard, LazyEmissionIntensityCardNew, LazyEmissionOverTimeChart, LazyEmissionsBreakdownAssetsSelector, LazyEmissionsBreakdownCategoriesSelector, LazyEmissionsIcon, LazyEmptyBoxShadowed, LazyEmptyDataIcon, LazyEmptyDonutPieChart, LazyEmptyEsgTopicMetrics, LazyEmptyFileIcon, LazyEmptyState, LazyEmptyStateTable, LazyEnvelopeIcon, LazyEquipmentIcon, LazyEsgArchiveTemplateModal, LazyEsgAssignAssetTreeNode, LazyEsgAssignRolesForm, LazyEsgAssignableAssetsTree, LazyEsgConfirmApprovalModal, LazyEsgCoveredDataModal, LazyEsgCreateMetricModal, LazyEsgCreateTemplateModal, LazyEsgDashboardMetricTable, LazyEsgDashboardTab, LazyEsgDataEntryDataTable, LazyEsgDataEntryDocumentPreview, LazyEsgDataEntryDocumentViewer, LazyEsgDataEntryMapping, LazyEsgDataEntryTablePreview, LazyEsgDataEntryTemplateTable, LazyEsgDataUploadMetricFilter, LazyEsgDataUploadMetricsAccordion, LazyEsgDataUploadPercentageLoader, LazyEsgExportTable, LazyEsgFrameworkPickerAccordion, LazyEsgFrameworkTopicMetricPicker, LazyEsgFrameworksPicker, LazyEsgManualEntryTable, LazyEsgMetricAssetAssignmentList, LazyEsgMetricAutoCompleteItem, LazyEsgMetricDataAssignmentTable, LazyEsgMetricForm, LazyEsgMetricOutputTable, LazyEsgMetricTemplatesTable, LazyEsgMetricViewRawData, LazyEsgMetricViewReportingTable, LazyEsgMetricsConfigurationTable, LazyEsgMetricsPicker, LazyEsgMetricsSelector, LazyEsgMetricsSelectorAccordion, LazyEsgMetricsTabHeader, LazyEsgMultiFileUpload, LazyEsgSelectMetricsTable, LazyEsgSubmissionComment, LazyEsgSubmissionRejectionModal, LazyEsgSubmissionStatusUserInitials, LazyEsgSubmissionViewCommentsModal, LazyEsgSubmissionsTable, LazyEsgSubmissionsTemplateDataTable, LazyEsgThemeAssignContainer, LazyEsgTopicMetricsAccordion, LazyEsgTopicMetricsAssignAccordion, LazyEsgTopicsPicker, LazyEsgUploadSupportingDocsModal, LazyEsgUploadTemplate, LazyEsgViewSupportingDocsModal, LazyExcelIcon, LazyExclamationIcon, LazyExpandIcon, LazyExternalLink, LazyEyeIcon, LazyEyeSlash, LazyFAQSection, LazyFBIcon, LazyFactoryIcon, LazyFeatureDetail, LazyFileAdd, LazyFileDescriptionIcon, LazyFileDocIcon, LazyFileDocument, LazyFileDocumentDownloadIcon, LazyFileDocumentPlus, LazyFileFilterDocumentSection, LazyFileIcon, LazyFileSearchIcon, LazyFileTextIcon, LazyFileUploadIcon, LazyFileUploadInput, LazyFileUploadSelectedCard, LazyFilterDocumentBadge, LazyFilterIcon, LazyFireIcon, LazyFooterSection, LazyFormIcon, LazyFourSquares, LazyFreetextAnswer, LazyFullPageLoader, LazyGHGIcon, LazyGRIBanner, LazyGeneralPaginator, LazyGeneralTabs, LazyGenerateReportsButton, LazyGeoLocationSelector, LazyGhgCoveredDataModal, LazyGhgDashboardTab, LazyGhgEmissionCards, LazyGhgEmissionChart, LazyGhgEmissionFactorConfigurationForm, LazyGhgEmissionFactorMatchingGroupForm, LazyGhgEmissionFactorMatchingTable, LazyGhgEmissionFactorPreConfigDataTable, LazyGhgEmissionTotal, LazyGhgEmissionsChartCard, LazyGhgHistoricalDataTable, LazyGhgRevenueDataTable, LazyGhgScopeLegends, LazyGhgTargetSettingChart, LazyGhostButton, LazyGhostButtonLink, LazyGhostUnoutlinedButton, LazyGlobeIcon, LazyGreetingsComponent, LazyGrobalEuropeAfricaIcon, LazyHamburgerMenu, LazyHeatandSteamGuideModal, LazyHelpIcon, LazyHelperText, LazyHeroGlobeSection, LazyHeroSection, LazyHistoryClock, LazyHomeNavbar, LazyHomeSmall, LazyHorizontalTabs, LazyHouseDuotone, LazyHowItWorkSection, LazyHowSection, LazyHubspotForm, LazyIconMenu, LazyIndustryDuotone, LazyInfiniteScrollDropdown, LazyInfiniteScrollReportingYearsMultiSelect, LazyInfoCircle, LazyInfoCircleBlueIcon, LazyInfoRoundedIcon, LazyInfoRoundedSmall, LazyInfoRoundedSmallThin, LazyInifiniteScrollTypeahead, LazyInputWithIcon, LazyInstaIcon, LazyIntroductionSection, LazyItalicIcon, LazyKeyIcon, LazyLabelChartBreakdown, LazyLabelsAutoComplete, LazyLanguageIcon, LazyLanguagePicker, LazyLayerPlus, LazyLifeOnLand, LazyLinkIcon, LazyLinkIcon2, LazyLinkedinIcon, LazyListUl, LazyLoaderComponent, LazyLockIcon, LazyLogIcon, LazyLoginComponent, LazyLoginWithMicrosoft, LazyLogoHomeButton, LazyLogosSection, LazyLogoutLarge, LazyMainHeader, LazyMaintenanceBanner, LazyManageAbatementButton, LazyManageAssetsModal, LazyManageMetrics, LazyManagePermission, LazyManageTemplates, LazyMapIcon, LazyMarketplaceGlobe, LazyMeasureIcon, LazyMenuFold, LazyMetricFormField, LazyMetricTable, LazyMicrosoftIcon, LazyMiniMultiSelector, LazyMinusCircle, LazyMinusCircleSmall, LazyMobileNavbar, LazyModalComponent, LazyModalContainer, LazyModalHeader, LazyMultiAssetsTreeSelector, LazyMultiFileUploadInput, LazyMultiSelector, LazyMultiTabs, LazyNewTabIcon, LazyNonPreconfiguredEfButtonTrigger, LazyNotificationComponent, LazyNotificationIcon, LazyNumberCounterInput, LazyNumberInput, LazyOptimizeIcon, LazyOptionsSelector, LazyPageHeaderBackButton, LazyPaperClipIcon, LazyPenIcon, LazyPhoneIcon, LazyPlayIcon, LazyPlusIcon, LazyPlusRoundedIcon, LazyPlusSmall, LazyPollutantSummary, LazyPollutantsPieChart, LazyPreloaderIcon, LazyPreviewEsgMetricTableModal, LazyPrimaryButton, LazyPrimaryButtonLink, LazyPrimaryOutlinedButton, LazyPrioritySelector, LazyProcessStepper, LazyProgressIcon, LazyProgressTrackerAssetTreeNode, LazyProgressTrackerAssetsTreeSelector, LazyProgressTrackerCategoriesMultiselect, LazyProgressTrackerComingSoon, LazyProgressTrackerFilter, LazyProgressTrackerMonthRangePicker, LazyProgressTrackerOwnerPendingEntries, LazyProgressTrackerOwnerPendingEntriesModal, LazyProgressTrackerPendingApprovals, LazyProgressTrackerPendingDataEntries, LazyProgressTrackerRejectedSubmissions, LazyPublishedQuestionsTable, LazyPurchaseInfoGuideModal, LazyQuestionMarkCircleLightSmall, LazyQuestionMarkCircleSmall, LazyRadioAnswer, LazyRefreshIcon, LazyRejectApprovalModal, LazyRejectedNotification, LazyRejectionMessageIcon, LazyRejectionMessageThread, LazyRejectionThreadModal, LazyReportAmoqComment, LazyReportIcon, LazyReportingCycle, LazyReportingFrameworksTemplateBuilder, LazyReportingIcon, LazyRequestEsgFrameworksButton, LazyResponsibleConsumptionAndProduction, LazyRestoreIcon, LazyRoadmapSection, LazyScopesChartGraph, LazySearchIcon, LazySearchRounded, LazySelectDocumentIcon, LazySelectEsgMetricsEmptyState, LazySelectedEmissionChart, LazySelectedPollutantCards, LazyShadDatePicker, LazySidebarComponent, LazySidebarMenuItem, LazySortIcon, LazySourceChartBreakdown, LazySourceForm, LazySourceTypesAccordion, LazySpinnerLarge, LazySquaresPlus, LazyStepsNavigation, LazyStepsNumberNavigation, LazySubscriptionForm, LazySubscriptionIcon, LazySuccessNotification, LazySuperAdminMenu, LazySupportIcon, LazySustainabilityScoreCard, LazySustainabilityTree, LazySustainableCitiesAndCommunities, LazySwitchOffIcon, LazySwitchOnIcon, LazyTableAnswer, LazyTableCellsIcon, LazyTableColumnFilter, LazyTableCountTitle, LazyTableFilter, LazyTableHeaderTooltip, LazyTabsInPills, LazyTagIcon, LazyTemplateFileIcon, LazyTestimonialsSection, LazyTextInput, LazyTextareaInput, LazyThemeLegendIndicator, LazyThreeBars, LazyTickRoundedIcon, LazyTierForm, LazyTiersTable, LazyTimeIcon, LazyTimesOutlineIcon, LazyTimesRoundedSmall, LazyTimesSmall, LazyTipTapInput, LazyTipTapRichtextDisplay, LazyToggleInput, LazyToolTip, LazyToolTipNew, LazyTopEmittingAssetsChart, LazyTopEmittingCategoriesChart, LazyTopEmittingLabelTotal, LazyTopEmittingLabelsBarChart, LazyTopEmittingLabelsPieChart, LazyTotalEmissionsCard, LazyTotalEmissionsCardNew, LazyTrashGreenIcon, LazyTrashIcon, LazyTrashLarge, LazyTrashSmall, LazyTrialBanner, LazyTwitterIcon, LazyTypeMultiSelector, LazyUnderlineIcon, LazyUnitsIcon, LazyUnlinkIcon, LazyUploadFileModal, LazyUploadIcon, LazyUploadSupportingDocsIcon, LazyUserCircleIcon, LazyUserDashboardMetricTabs, LazyUserIcon, LazyUserInitialsDefaultContainer, LazyUserInitialsTableCell, LazyUserMenu, LazyUserMenuComponent, LazyUserPlusLarge, LazyVeridisLogo, LazyVerticalTabs, LazyViewLog, LazyViewLogsButton, LazyWarningIcon, LazyWordDocumentIcon, LazyWrenchIcon, LazyXCircleIcon, LazyYokogawaLogo, LazyZoomInIcon, LazyZoomOutIcon, LazyZunoEngineerMenu, LazyDataUploadReviewLegacy, LazyDataUploadReviewNew, LazyEfMatchingColumns, LazyEsgDataEntryManualColumns, LazyEsgDataEntrySubmissionsColumns, LazyEsgMetricsConfigurationColumns, LazyEsgMetricsConfigurationSelectColumns, LazyEsgMetricsExportColumns, LazyEsgMetricsRawDataColumns, LazyEsgMetricsRawDataSubmissionColumns, LazyEsgMetricsTemplatesColumns, LazyEsgSubmissionsColumns, LazyEsgSubmissionsEditColumns, LazyGhgPreconfigColumns, LazyGhgPreconfigDataListColumns, LazyProgressTrackerPendingApprovalsColumns, LazyProgressTrackerPendingDataEntriesColumns, LazyProgressTrackerPendingDataEntriesDataOwnerColumns, LazyProgressTrackerRejectedSubmissionsColumns, LazyTiptapEditorCustomMention, LazyTiptapEditorTipTapMentionList, LazyTiptapEditorTipTapSuggestion, LazyTiptapEditorTipTapToggleButton, LazyVuejsDatepickerDateInput, LazyVuejsDatepickerPickerDay, LazyVuejsDatepickerPickerMonth, LazyVuejsDatepickerPickerYear } from '#components'
const lazyGlobalComponents = [
  ["AbatementIcon", LazyAbatementIcon],
["AddManageSectionsButton", LazyAddManageSectionsButton],
["AlphabeticSortIcon", LazyAlphabeticSortIcon],
["AmoqComment", LazyAmoqComment],
["AmoqCommentThread", LazyAmoqCommentThread],
["AmoqGuidance", LazyAmoqGuidance],
["AmoqQuestion", LazyAmoqQuestion],
["AmoqQuestionSelect", LazyAmoqQuestionSelect],
["AmoqQuestionSummary", LazyAmoqQuestionSummary],
["AmoqQuestionsNavigation", LazyAmoqQuestionsNavigation],
["AnimatedCircleLoader", LazyAnimatedCircleLoader],
["AnimatedPing", LazyAnimatedPing],
["ApproveApprovalModal", LazyApproveApprovalModal],
["ArchiveIcon", LazyArchiveIcon],
["ArrowDownIcon", LazyArrowDownIcon],
["ArrowNarrowLeftSmall", LazyArrowNarrowLeftSmall],
["ArrowUpIcon", LazyArrowUpIcon],
["ArrowUpTray", LazyArrowUpTray],
["ArrowVector", LazyArrowVector],
["ArrowWideLeft", LazyArrowWideLeft],
["AssetChartBreakdown", LazyAssetChartBreakdown],
["AssetTreeNode", LazyAssetTreeNode],
["AssetsTreeSelector", LazyAssetsTreeSelector],
["AssignRolesModal", LazyAssignRolesModal],
["AsyncMultiSelector", LazyAsyncMultiSelector],
["AttachmentListContainer", LazyAttachmentListContainer],
["AttachmentListModal", LazyAttachmentListModal],
["AttachmentViewer", LazyAttachmentViewer],
["AutoCompleteInput", LazyAutoCompleteInput],
["BankIcon", LazyBankIcon],
["BarsArrowUp", LazyBarsArrowUp],
["BaseButton", LazyBaseButton],
["BaseYearToggle", LazyBaseYearToggle],
["BellSmall", LazyBellSmall],
["BenefitCard", LazyBenefitCard],
["BenefitsSection", LazyBenefitsSection],
["BlockedAlert", LazyBlockedAlert],
["BoldIcon", LazyBoldIcon],
["BoltDuotone", LazyBoltDuotone],
["BookmarkIcon", LazyBookmarkIcon],
["BooleanIconOrDescription", LazyBooleanIconOrDescription],
["BorderedRadioButtonWithInfo", LazyBorderedRadioButtonWithInfo],
["BoxIcon", LazyBoxIcon],
["BoxUploadIcon", LazyBoxUploadIcon],
["BreadCrumb", LazyBreadCrumb],
["BriefCase", LazyBriefCase],
["BuildingIcon", LazyBuildingIcon],
["BulletListIcon", LazyBulletListIcon],
["BusIcon", LazyBusIcon],
["ButtonWithIcon", LazyButtonWithIcon],
["CTASection", LazyCTASection],
["CalendarIcon", LazyCalendarIcon],
["CallIcon", LazyCallIcon],
["CarbonEquivalenceCalculator", LazyCarbonEquivalenceCalculator],
["CarbonEquivalenceCalculatorNew", LazyCarbonEquivalenceCalculatorNew],
["CarbonFire", LazyCarbonFire],
["CartIcon", LazyCartIcon],
["CategoriesOvertimeBadges", LazyCategoriesOvertimeBadges],
["CategoryButton", LazyCategoryButton],
["ChartIcon", LazyChartIcon],
["CheckApproval", LazyCheckApproval],
["CheckCircleIcon", LazyCheckCircleIcon],
["CheckOutlineIcon", LazyCheckOutlineIcon],
["CheckRejected", LazyCheckRejected],
["CheckRoundedSmall", LazyCheckRoundedSmall],
["CheckSmall", LazyCheckSmall],
["CheckboxAnswer", LazyCheckboxAnswer],
["ChevronDoubleDownSmall", LazyChevronDoubleDownSmall],
["ChevronDoubleUpSmall", LazyChevronDoubleUpSmall],
["ChevronDownLarge", LazyChevronDownLarge],
["ChevronDownSmall", LazyChevronDownSmall],
["ChevronLeftSmall", LazyChevronLeftSmall],
["ChevronNav", LazyChevronNav],
["ChevronRightSmall", LazyChevronRightSmall],
["ChevronUpSmall", LazyChevronUpSmall],
["CircleRoundedIcon", LazyCircleRoundedIcon],
["ClockIcon", LazyClockIcon],
["CloseIcon", LazyCloseIcon],
["CloseRoundedIcon", LazyCloseRoundedIcon],
["CloudDownload", LazyCloudDownload],
["CloudIcon", LazyCloudIcon],
["CloudUpload", LazyCloudUpload],
["CloudUploadSmall", LazyCloudUploadSmall],
["CodeHighlight", LazyCodeHighlight],
["CogIcon", LazyCogIcon],
["ComingSoonIllustration", LazyComingSoonIllustration],
["CommentText", LazyCommentText],
["ConfigureEsgMetricsEmptyState", LazyConfigureEsgMetricsEmptyState],
["ConfigureGhgEmissionFactorModal", LazyConfigureGhgEmissionFactorModal],
["ConfirmDialog", LazyConfirmDialog],
["ConfirmEditSubmissionModal", LazyConfirmEditSubmissionModal],
["ConfirmMessageModal", LazyConfirmMessageModal],
["ConnectIcon", LazyConnectIcon],
["ConsolidationApproachSelectionModal", LazyConsolidationApproachSelectionModal],
["CrudMetricForm", LazyCrudMetricForm],
["CsvLarge", LazyCsvLarge],
["CtaSection", LazyCtaSection],
["CubeIcon", LazyCubeIcon],
["CustomDashboardTab", LazyCustomDashboardTab],
["DashboardIcon", LazyDashboardIcon],
["DashboardNavbarComponent", LazyDashboardNavbarComponent],
["DataAssignmentBulkImportForm", LazyDataAssignmentBulkImportForm],
["DataAssignmentModal", LazyDataAssignmentModal],
["DataAssignmentNodeSelector", LazyDataAssignmentNodeSelector],
["DataAssignmentRadioSelector", LazyDataAssignmentRadioSelector],
["DataAssignmentTable", LazyDataAssignmentTable],
["DataAssignmentTreeSelector", LazyDataAssignmentTreeSelector],
["DataAssignmentUserSelector", LazyDataAssignmentUserSelector],
["DataEntryDocument", LazyDataEntryDocument],
["DataPointAttachmentContainer", LazyDataPointAttachmentContainer],
["DataRangeFilter", LazyDataRangeFilter],
["DataTableEmptyState", LazyDataTableEmptyState],
["DatapointIntegration", LazyDatapointIntegration],
["DatePicker", LazyDatePicker],
["DateRangeIcon", LazyDateRangeIcon],
["DateRangePicker", LazyDateRangePicker],
["DecentWorkAndEconomicGrowth", LazyDecentWorkAndEconomicGrowth],
["DestructivePrimaryButton", LazyDestructivePrimaryButton],
["DotsHorizontal", LazyDotsHorizontal],
["DotsVerticalSmall", LazyDotsVerticalSmall],
["DottedCircleIcon", LazyDottedCircleIcon],
["DoubleCheck", LazyDoubleCheck],
["DownloadIcon", LazyDownloadIcon],
["DraftQuestionsTable", LazyDraftQuestionsTable],
["DragDropInput", LazyDragDropInput],
["DropDown", LazyDropDown],
["DropDownInput", LazyDropDownInput],
["DropFileInput", LazyDropFileInput],
["DropdownAnswer", LazyDropdownAnswer],
["DropdownIcon", LazyDropdownIcon],
["DropdownMenu", LazyDropdownMenu],
["DropdownMenuItem", LazyDropdownMenuItem],
["EarthSettingIcon", LazyEarthSettingIcon],
["EditEmissionAuditLogModal", LazyEditEmissionAuditLogModal],
["EditGhgEmissionFactorModal", LazyEditGhgEmissionFactorModal],
["EditGhgEmissionFactorReviewModal", LazyEditGhgEmissionFactorReviewModal],
["EditUserIcon", LazyEditUserIcon],
["ElpHorizontal", LazyElpHorizontal],
["ElpIcon", LazyElpIcon],
["EmissionByCategoryOverTimeChart", LazyEmissionByCategoryOverTimeChart],
["EmissionByScopeOverTimeChart", LazyEmissionByScopeOverTimeChart],
["EmissionFactorItem", LazyEmissionFactorItem],
["EmissionFactorPicker", LazyEmissionFactorPicker],
["EmissionIntensityCard", LazyEmissionIntensityCard],
["EmissionIntensityCardNew", LazyEmissionIntensityCardNew],
["EmissionOverTimeChart", LazyEmissionOverTimeChart],
["EmissionsBreakdownAssetsSelector", LazyEmissionsBreakdownAssetsSelector],
["EmissionsBreakdownCategoriesSelector", LazyEmissionsBreakdownCategoriesSelector],
["EmissionsIcon", LazyEmissionsIcon],
["EmptyBoxShadowed", LazyEmptyBoxShadowed],
["EmptyDataIcon", LazyEmptyDataIcon],
["EmptyDonutPieChart", LazyEmptyDonutPieChart],
["EmptyEsgTopicMetrics", LazyEmptyEsgTopicMetrics],
["EmptyFileIcon", LazyEmptyFileIcon],
["EmptyState", LazyEmptyState],
["EmptyStateTable", LazyEmptyStateTable],
["EnvelopeIcon", LazyEnvelopeIcon],
["EquipmentIcon", LazyEquipmentIcon],
["EsgArchiveTemplateModal", LazyEsgArchiveTemplateModal],
["EsgAssignAssetTreeNode", LazyEsgAssignAssetTreeNode],
["EsgAssignRolesForm", LazyEsgAssignRolesForm],
["EsgAssignableAssetsTree", LazyEsgAssignableAssetsTree],
["EsgConfirmApprovalModal", LazyEsgConfirmApprovalModal],
["EsgCoveredDataModal", LazyEsgCoveredDataModal],
["EsgCreateMetricModal", LazyEsgCreateMetricModal],
["EsgCreateTemplateModal", LazyEsgCreateTemplateModal],
["EsgDashboardMetricTable", LazyEsgDashboardMetricTable],
["EsgDashboardTab", LazyEsgDashboardTab],
["EsgDataEntryDataTable", LazyEsgDataEntryDataTable],
["EsgDataEntryDocumentPreview", LazyEsgDataEntryDocumentPreview],
["EsgDataEntryDocumentViewer", LazyEsgDataEntryDocumentViewer],
["EsgDataEntryMapping", LazyEsgDataEntryMapping],
["EsgDataEntryTablePreview", LazyEsgDataEntryTablePreview],
["EsgDataEntryTemplateTable", LazyEsgDataEntryTemplateTable],
["EsgDataUploadMetricFilter", LazyEsgDataUploadMetricFilter],
["EsgDataUploadMetricsAccordion", LazyEsgDataUploadMetricsAccordion],
["EsgDataUploadPercentageLoader", LazyEsgDataUploadPercentageLoader],
["EsgExportTable", LazyEsgExportTable],
["EsgFrameworkPickerAccordion", LazyEsgFrameworkPickerAccordion],
["EsgFrameworkTopicMetricPicker", LazyEsgFrameworkTopicMetricPicker],
["EsgFrameworksPicker", LazyEsgFrameworksPicker],
["EsgManualEntryTable", LazyEsgManualEntryTable],
["EsgMetricAssetAssignmentList", LazyEsgMetricAssetAssignmentList],
["EsgMetricAutoCompleteItem", LazyEsgMetricAutoCompleteItem],
["EsgMetricDataAssignmentTable", LazyEsgMetricDataAssignmentTable],
["EsgMetricForm", LazyEsgMetricForm],
["EsgMetricOutputTable", LazyEsgMetricOutputTable],
["EsgMetricTemplatesTable", LazyEsgMetricTemplatesTable],
["EsgMetricViewRawData", LazyEsgMetricViewRawData],
["EsgMetricViewReportingTable", LazyEsgMetricViewReportingTable],
["EsgMetricsConfigurationTable", LazyEsgMetricsConfigurationTable],
["EsgMetricsPicker", LazyEsgMetricsPicker],
["EsgMetricsSelector", LazyEsgMetricsSelector],
["EsgMetricsSelectorAccordion", LazyEsgMetricsSelectorAccordion],
["EsgMetricsTabHeader", LazyEsgMetricsTabHeader],
["EsgMultiFileUpload", LazyEsgMultiFileUpload],
["EsgSelectMetricsTable", LazyEsgSelectMetricsTable],
["EsgSubmissionComment", LazyEsgSubmissionComment],
["EsgSubmissionRejectionModal", LazyEsgSubmissionRejectionModal],
["EsgSubmissionStatusUserInitials", LazyEsgSubmissionStatusUserInitials],
["EsgSubmissionViewCommentsModal", LazyEsgSubmissionViewCommentsModal],
["EsgSubmissionsTable", LazyEsgSubmissionsTable],
["EsgSubmissionsTemplateDataTable", LazyEsgSubmissionsTemplateDataTable],
["EsgThemeAssignContainer", LazyEsgThemeAssignContainer],
["EsgTopicMetricsAccordion", LazyEsgTopicMetricsAccordion],
["EsgTopicMetricsAssignAccordion", LazyEsgTopicMetricsAssignAccordion],
["EsgTopicsPicker", LazyEsgTopicsPicker],
["EsgUploadSupportingDocsModal", LazyEsgUploadSupportingDocsModal],
["EsgUploadTemplate", LazyEsgUploadTemplate],
["EsgViewSupportingDocsModal", LazyEsgViewSupportingDocsModal],
["ExcelIcon", LazyExcelIcon],
["ExclamationIcon", LazyExclamationIcon],
["ExpandIcon", LazyExpandIcon],
["ExternalLink", LazyExternalLink],
["EyeIcon", LazyEyeIcon],
["EyeSlash", LazyEyeSlash],
["FAQSection", LazyFAQSection],
["FBIcon", LazyFBIcon],
["FactoryIcon", LazyFactoryIcon],
["FeatureDetail", LazyFeatureDetail],
["FileAdd", LazyFileAdd],
["FileDescriptionIcon", LazyFileDescriptionIcon],
["FileDocIcon", LazyFileDocIcon],
["FileDocument", LazyFileDocument],
["FileDocumentDownloadIcon", LazyFileDocumentDownloadIcon],
["FileDocumentPlus", LazyFileDocumentPlus],
["FileFilterDocumentSection", LazyFileFilterDocumentSection],
["FileIcon", LazyFileIcon],
["FileSearchIcon", LazyFileSearchIcon],
["FileTextIcon", LazyFileTextIcon],
["FileUploadIcon", LazyFileUploadIcon],
["FileUploadInput", LazyFileUploadInput],
["FileUploadSelectedCard", LazyFileUploadSelectedCard],
["FilterDocumentBadge", LazyFilterDocumentBadge],
["FilterIcon", LazyFilterIcon],
["FireIcon", LazyFireIcon],
["FooterSection", LazyFooterSection],
["FormIcon", LazyFormIcon],
["FourSquares", LazyFourSquares],
["FreetextAnswer", LazyFreetextAnswer],
["FullPageLoader", LazyFullPageLoader],
["GHGIcon", LazyGHGIcon],
["GRIBanner", LazyGRIBanner],
["GeneralPaginator", LazyGeneralPaginator],
["GeneralTabs", LazyGeneralTabs],
["GenerateReportsButton", LazyGenerateReportsButton],
["GeoLocationSelector", LazyGeoLocationSelector],
["GhgCoveredDataModal", LazyGhgCoveredDataModal],
["GhgDashboardTab", LazyGhgDashboardTab],
["GhgEmissionCards", LazyGhgEmissionCards],
["GhgEmissionChart", LazyGhgEmissionChart],
["GhgEmissionFactorConfigurationForm", LazyGhgEmissionFactorConfigurationForm],
["GhgEmissionFactorMatchingGroupForm", LazyGhgEmissionFactorMatchingGroupForm],
["GhgEmissionFactorMatchingTable", LazyGhgEmissionFactorMatchingTable],
["GhgEmissionFactorPreConfigDataTable", LazyGhgEmissionFactorPreConfigDataTable],
["GhgEmissionTotal", LazyGhgEmissionTotal],
["GhgEmissionsChartCard", LazyGhgEmissionsChartCard],
["GhgHistoricalDataTable", LazyGhgHistoricalDataTable],
["GhgRevenueDataTable", LazyGhgRevenueDataTable],
["GhgScopeLegends", LazyGhgScopeLegends],
["GhgTargetSettingChart", LazyGhgTargetSettingChart],
["GhostButton", LazyGhostButton],
["GhostButtonLink", LazyGhostButtonLink],
["GhostUnoutlinedButton", LazyGhostUnoutlinedButton],
["GlobeIcon", LazyGlobeIcon],
["GreetingsComponent", LazyGreetingsComponent],
["GrobalEuropeAfricaIcon", LazyGrobalEuropeAfricaIcon],
["HamburgerMenu", LazyHamburgerMenu],
["HeatandSteamGuideModal", LazyHeatandSteamGuideModal],
["HelpIcon", LazyHelpIcon],
["HelperText", LazyHelperText],
["HeroGlobeSection", LazyHeroGlobeSection],
["HeroSection", LazyHeroSection],
["HistoryClock", LazyHistoryClock],
["HomeNavbar", LazyHomeNavbar],
["HomeSmall", LazyHomeSmall],
["HorizontalTabs", LazyHorizontalTabs],
["HouseDuotone", LazyHouseDuotone],
["HowItWorkSection", LazyHowItWorkSection],
["HowSection", LazyHowSection],
["HubspotForm", LazyHubspotForm],
["IconMenu", LazyIconMenu],
["IndustryDuotone", LazyIndustryDuotone],
["InfiniteScrollDropdown", LazyInfiniteScrollDropdown],
["InfiniteScrollReportingYearsMultiSelect", LazyInfiniteScrollReportingYearsMultiSelect],
["InfoCircle", LazyInfoCircle],
["InfoCircleBlueIcon", LazyInfoCircleBlueIcon],
["InfoRoundedIcon", LazyInfoRoundedIcon],
["InfoRoundedSmall", LazyInfoRoundedSmall],
["InfoRoundedSmallThin", LazyInfoRoundedSmallThin],
["InifiniteScrollTypeahead", LazyInifiniteScrollTypeahead],
["InputWithIcon", LazyInputWithIcon],
["InstaIcon", LazyInstaIcon],
["IntroductionSection", LazyIntroductionSection],
["ItalicIcon", LazyItalicIcon],
["KeyIcon", LazyKeyIcon],
["LabelChartBreakdown", LazyLabelChartBreakdown],
["LabelsAutoComplete", LazyLabelsAutoComplete],
["LanguageIcon", LazyLanguageIcon],
["LanguagePicker", LazyLanguagePicker],
["LayerPlus", LazyLayerPlus],
["LifeOnLand", LazyLifeOnLand],
["LinkIcon", LazyLinkIcon],
["LinkIcon2", LazyLinkIcon2],
["LinkedinIcon", LazyLinkedinIcon],
["ListUl", LazyListUl],
["LoaderComponent", LazyLoaderComponent],
["LockIcon", LazyLockIcon],
["LogIcon", LazyLogIcon],
["LoginComponent", LazyLoginComponent],
["LoginWithMicrosoft", LazyLoginWithMicrosoft],
["LogoHomeButton", LazyLogoHomeButton],
["LogosSection", LazyLogosSection],
["LogoutLarge", LazyLogoutLarge],
["MainHeader", LazyMainHeader],
["MaintenanceBanner", LazyMaintenanceBanner],
["ManageAbatementButton", LazyManageAbatementButton],
["ManageAssetsModal", LazyManageAssetsModal],
["ManageMetrics", LazyManageMetrics],
["ManagePermission", LazyManagePermission],
["ManageTemplates", LazyManageTemplates],
["MapIcon", LazyMapIcon],
["MarketplaceGlobe", LazyMarketplaceGlobe],
["MeasureIcon", LazyMeasureIcon],
["MenuFold", LazyMenuFold],
["MetricFormField", LazyMetricFormField],
["MetricTable", LazyMetricTable],
["MicrosoftIcon", LazyMicrosoftIcon],
["MiniMultiSelector", LazyMiniMultiSelector],
["MinusCircle", LazyMinusCircle],
["MinusCircleSmall", LazyMinusCircleSmall],
["MobileNavbar", LazyMobileNavbar],
["ModalComponent", LazyModalComponent],
["ModalContainer", LazyModalContainer],
["ModalHeader", LazyModalHeader],
["MultiAssetsTreeSelector", LazyMultiAssetsTreeSelector],
["MultiFileUploadInput", LazyMultiFileUploadInput],
["MultiSelector", LazyMultiSelector],
["MultiTabs", LazyMultiTabs],
["NewTabIcon", LazyNewTabIcon],
["NonPreconfiguredEfButtonTrigger", LazyNonPreconfiguredEfButtonTrigger],
["NotificationComponent", LazyNotificationComponent],
["NotificationIcon", LazyNotificationIcon],
["NumberCounterInput", LazyNumberCounterInput],
["NumberInput", LazyNumberInput],
["OptimizeIcon", LazyOptimizeIcon],
["OptionsSelector", LazyOptionsSelector],
["PageHeaderBackButton", LazyPageHeaderBackButton],
["PaperClipIcon", LazyPaperClipIcon],
["PenIcon", LazyPenIcon],
["PhoneIcon", LazyPhoneIcon],
["PlayIcon", LazyPlayIcon],
["PlusIcon", LazyPlusIcon],
["PlusRoundedIcon", LazyPlusRoundedIcon],
["PlusSmall", LazyPlusSmall],
["PollutantSummary", LazyPollutantSummary],
["PollutantsPieChart", LazyPollutantsPieChart],
["PreloaderIcon", LazyPreloaderIcon],
["PreviewEsgMetricTableModal", LazyPreviewEsgMetricTableModal],
["PrimaryButton", LazyPrimaryButton],
["PrimaryButtonLink", LazyPrimaryButtonLink],
["PrimaryOutlinedButton", LazyPrimaryOutlinedButton],
["PrioritySelector", LazyPrioritySelector],
["ProcessStepper", LazyProcessStepper],
["ProgressIcon", LazyProgressIcon],
["ProgressTrackerAssetTreeNode", LazyProgressTrackerAssetTreeNode],
["ProgressTrackerAssetsTreeSelector", LazyProgressTrackerAssetsTreeSelector],
["ProgressTrackerCategoriesMultiselect", LazyProgressTrackerCategoriesMultiselect],
["ProgressTrackerComingSoon", LazyProgressTrackerComingSoon],
["ProgressTrackerFilter", LazyProgressTrackerFilter],
["ProgressTrackerMonthRangePicker", LazyProgressTrackerMonthRangePicker],
["ProgressTrackerOwnerPendingEntries", LazyProgressTrackerOwnerPendingEntries],
["ProgressTrackerOwnerPendingEntriesModal", LazyProgressTrackerOwnerPendingEntriesModal],
["ProgressTrackerPendingApprovals", LazyProgressTrackerPendingApprovals],
["ProgressTrackerPendingDataEntries", LazyProgressTrackerPendingDataEntries],
["ProgressTrackerRejectedSubmissions", LazyProgressTrackerRejectedSubmissions],
["PublishedQuestionsTable", LazyPublishedQuestionsTable],
["PurchaseInfoGuideModal", LazyPurchaseInfoGuideModal],
["QuestionMarkCircleLightSmall", LazyQuestionMarkCircleLightSmall],
["QuestionMarkCircleSmall", LazyQuestionMarkCircleSmall],
["RadioAnswer", LazyRadioAnswer],
["RefreshIcon", LazyRefreshIcon],
["RejectApprovalModal", LazyRejectApprovalModal],
["RejectedNotification", LazyRejectedNotification],
["RejectionMessageIcon", LazyRejectionMessageIcon],
["RejectionMessageThread", LazyRejectionMessageThread],
["RejectionThreadModal", LazyRejectionThreadModal],
["ReportAmoqComment", LazyReportAmoqComment],
["ReportIcon", LazyReportIcon],
["ReportingCycle", LazyReportingCycle],
["ReportingFrameworksTemplateBuilder", LazyReportingFrameworksTemplateBuilder],
["ReportingIcon", LazyReportingIcon],
["RequestEsgFrameworksButton", LazyRequestEsgFrameworksButton],
["ResponsibleConsumptionAndProduction", LazyResponsibleConsumptionAndProduction],
["RestoreIcon", LazyRestoreIcon],
["RoadmapSection", LazyRoadmapSection],
["ScopesChartGraph", LazyScopesChartGraph],
["SearchIcon", LazySearchIcon],
["SearchRounded", LazySearchRounded],
["SelectDocumentIcon", LazySelectDocumentIcon],
["SelectEsgMetricsEmptyState", LazySelectEsgMetricsEmptyState],
["SelectedEmissionChart", LazySelectedEmissionChart],
["SelectedPollutantCards", LazySelectedPollutantCards],
["ShadDatePicker", LazyShadDatePicker],
["SidebarComponent", LazySidebarComponent],
["SidebarMenuItem", LazySidebarMenuItem],
["SortIcon", LazySortIcon],
["SourceChartBreakdown", LazySourceChartBreakdown],
["SourceForm", LazySourceForm],
["SourceTypesAccordion", LazySourceTypesAccordion],
["SpinnerLarge", LazySpinnerLarge],
["SquaresPlus", LazySquaresPlus],
["StepsNavigation", LazyStepsNavigation],
["StepsNumberNavigation", LazyStepsNumberNavigation],
["SubscriptionForm", LazySubscriptionForm],
["SubscriptionIcon", LazySubscriptionIcon],
["SuccessNotification", LazySuccessNotification],
["SuperAdminMenu", LazySuperAdminMenu],
["SupportIcon", LazySupportIcon],
["SustainabilityScoreCard", LazySustainabilityScoreCard],
["SustainabilityTree", LazySustainabilityTree],
["SustainableCitiesAndCommunities", LazySustainableCitiesAndCommunities],
["SwitchOffIcon", LazySwitchOffIcon],
["SwitchOnIcon", LazySwitchOnIcon],
["TableAnswer", LazyTableAnswer],
["TableCellsIcon", LazyTableCellsIcon],
["TableColumnFilter", LazyTableColumnFilter],
["TableCountTitle", LazyTableCountTitle],
["TableFilter", LazyTableFilter],
["TableHeaderTooltip", LazyTableHeaderTooltip],
["TabsInPills", LazyTabsInPills],
["TagIcon", LazyTagIcon],
["TemplateFileIcon", LazyTemplateFileIcon],
["TestimonialsSection", LazyTestimonialsSection],
["TextInput", LazyTextInput],
["TextareaInput", LazyTextareaInput],
["ThemeLegendIndicator", LazyThemeLegendIndicator],
["ThreeBars", LazyThreeBars],
["TickRoundedIcon", LazyTickRoundedIcon],
["TierForm", LazyTierForm],
["TiersTable", LazyTiersTable],
["TimeIcon", LazyTimeIcon],
["TimesOutlineIcon", LazyTimesOutlineIcon],
["TimesRoundedSmall", LazyTimesRoundedSmall],
["TimesSmall", LazyTimesSmall],
["TipTapInput", LazyTipTapInput],
["TipTapRichtextDisplay", LazyTipTapRichtextDisplay],
["ToggleInput", LazyToggleInput],
["ToolTip", LazyToolTip],
["ToolTipNew", LazyToolTipNew],
["TopEmittingAssetsChart", LazyTopEmittingAssetsChart],
["TopEmittingCategoriesChart", LazyTopEmittingCategoriesChart],
["TopEmittingLabelTotal", LazyTopEmittingLabelTotal],
["TopEmittingLabelsBarChart", LazyTopEmittingLabelsBarChart],
["TopEmittingLabelsPieChart", LazyTopEmittingLabelsPieChart],
["TotalEmissionsCard", LazyTotalEmissionsCard],
["TotalEmissionsCardNew", LazyTotalEmissionsCardNew],
["TrashGreenIcon", LazyTrashGreenIcon],
["TrashIcon", LazyTrashIcon],
["TrashLarge", LazyTrashLarge],
["TrashSmall", LazyTrashSmall],
["TrialBanner", LazyTrialBanner],
["TwitterIcon", LazyTwitterIcon],
["TypeMultiSelector", LazyTypeMultiSelector],
["UnderlineIcon", LazyUnderlineIcon],
["UnitsIcon", LazyUnitsIcon],
["UnlinkIcon", LazyUnlinkIcon],
["UploadFileModal", LazyUploadFileModal],
["UploadIcon", LazyUploadIcon],
["UploadSupportingDocsIcon", LazyUploadSupportingDocsIcon],
["UserCircleIcon", LazyUserCircleIcon],
["UserDashboardMetricTabs", LazyUserDashboardMetricTabs],
["UserIcon", LazyUserIcon],
["UserInitialsDefaultContainer", LazyUserInitialsDefaultContainer],
["UserInitialsTableCell", LazyUserInitialsTableCell],
["UserMenu", LazyUserMenu],
["UserMenuComponent", LazyUserMenuComponent],
["UserPlusLarge", LazyUserPlusLarge],
["VeridisLogo", LazyVeridisLogo],
["VerticalTabs", LazyVerticalTabs],
["ViewLog", LazyViewLog],
["ViewLogsButton", LazyViewLogsButton],
["WarningIcon", LazyWarningIcon],
["WordDocumentIcon", LazyWordDocumentIcon],
["WrenchIcon", LazyWrenchIcon],
["XCircleIcon", LazyXCircleIcon],
["YokogawaLogo", LazyYokogawaLogo],
["ZoomInIcon", LazyZoomInIcon],
["ZoomOutIcon", LazyZoomOutIcon],
["ZunoEngineerMenu", LazyZunoEngineerMenu],
["DataUploadReviewLegacy", LazyDataUploadReviewLegacy],
["DataUploadReviewNew", LazyDataUploadReviewNew],
["EfMatchingColumns", LazyEfMatchingColumns],
["EsgDataEntryManualColumns", LazyEsgDataEntryManualColumns],
["EsgDataEntrySubmissionsColumns", LazyEsgDataEntrySubmissionsColumns],
["EsgMetricsConfigurationColumns", LazyEsgMetricsConfigurationColumns],
["EsgMetricsConfigurationSelectColumns", LazyEsgMetricsConfigurationSelectColumns],
["EsgMetricsExportColumns", LazyEsgMetricsExportColumns],
["EsgMetricsRawDataColumns", LazyEsgMetricsRawDataColumns],
["EsgMetricsRawDataSubmissionColumns", LazyEsgMetricsRawDataSubmissionColumns],
["EsgMetricsTemplatesColumns", LazyEsgMetricsTemplatesColumns],
["EsgSubmissionsColumns", LazyEsgSubmissionsColumns],
["EsgSubmissionsEditColumns", LazyEsgSubmissionsEditColumns],
["GhgPreconfigColumns", LazyGhgPreconfigColumns],
["GhgPreconfigDataListColumns", LazyGhgPreconfigDataListColumns],
["ProgressTrackerPendingApprovalsColumns", LazyProgressTrackerPendingApprovalsColumns],
["ProgressTrackerPendingDataEntriesColumns", LazyProgressTrackerPendingDataEntriesColumns],
["ProgressTrackerPendingDataEntriesDataOwnerColumns", LazyProgressTrackerPendingDataEntriesDataOwnerColumns],
["ProgressTrackerRejectedSubmissionsColumns", LazyProgressTrackerRejectedSubmissionsColumns],
["TiptapEditorCustomMention", LazyTiptapEditorCustomMention],
["TiptapEditorTipTapMentionList", LazyTiptapEditorTipTapMentionList],
["TiptapEditorTipTapSuggestion", LazyTiptapEditorTipTapSuggestion],
["TiptapEditorTipTapToggleButton", LazyTiptapEditorTipTapToggleButton],
["VuejsDatepickerDateInput", LazyVuejsDatepickerDateInput],
["VuejsDatepickerPickerDay", LazyVuejsDatepickerPickerDay],
["VuejsDatepickerPickerMonth", LazyVuejsDatepickerPickerMonth],
["VuejsDatepickerPickerYear", LazyVuejsDatepickerPickerYear],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
